import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { WizardProvider } from '../../context/wizard/provider';
import { useHostContext } from 'src/core/hooks/useHostContext';
import { DataHubService } from 'src/core/services/datahub';
import { ViewModuleCreateBottomsheetSchema } from 'src/core/services/datahub/schemas/modules/viewModuleCreateBottomsheetSchema';
import { Dialog } from './dialog';
import invalidateProductQueries from './invalidateProductQueries';
export function ManageModule() {
    const { moduleId } = useParams();
    const { arrivedFrom } = useHostContext();
    invalidateProductQueries();
    const isUpdate = Boolean(moduleId) && moduleId !== 'new';
    const steps = isUpdate ? ['mainForm'] : ['moduleType', 'mainForm'];
    useEffect(function effectDispatchEvent() {
        const previousPage = arrivedFrom || 'DIRECT';
        DataHubService.sendEvent({
            schema: new ViewModuleCreateBottomsheetSchema({
                arrivedFrom: previousPage
            })
        });
    }, [arrivedFrom]);
    return (_jsx(WizardProvider, { steps: steps, children: _jsx(Dialog, { isUpdate: isUpdate }) }));
}
